export const LOAD_ESCOLAS = 'LOAD_ESCOLAS'



// WEBPACK FOOTER //
// ./src/store/modules/pesquisa_aulas/types.js